<template>
  <div class="border rounded h-100 d-flex flex-column align-items-center justify-content-start pt-3">
    <label :for="scopeToId([...scope, 'spacing'])" class="form-label">
      {{ $t("backend.candidacy.components.jumbotron.spacing") }}
      <strong>[{{ currentValue }}px]</strong>
    </label>

    <input
      type="range"
      v-model="currentValue"
      :name='scopeToName([...scope, "spacing"])'
      :id="scopeToId([...scope, 'spacing'])"
      class="form-range px-4 pt-4"
      min="16"
      max="64"
      step="4"
    />
  </div>
</template>

<script setup lang="ts">
import { scopeToName, scopeToId } from "@/lib/candidacy/form_builder/utils";
import type { PropType } from "@/types";
import { ref, watch } from "vue";

const emits = defineEmits(["update:spacing"]);

const props = defineProps({
  spacing: {
    type: Number,
    required: true,
  },
  scope: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const currentValue = ref<number>(props.spacing);

watch(currentValue, () => emits("update:spacing", Number(currentValue.value)));
</script>
